<template>
  <section class="section">
    <div class="container" style="margin-top: -30px;">
      <div class="columns" >
        <div class="column">
          <span class="title24"> {{ selectedEventName }}</span>
        </div>
          
      </div>

      <b-field class="title24" >ຟອມຄົ້ນຫາເບີໂທ</b-field>  
        <div style="margin-top: 15px;">  
          <div class="columns" >
            <div class="column">
              <div class="columns" style="margin-bottom: 30px;">
                <div class="column">
                  <b-field label="ຄົ້ນຫາເບີໂທ">
                    <b-input
                      v-model.trim="regsiterByPhoneno"
                      type="text"
                    >   
                    </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-button  style="margin-top: 0px;"
                        class="btn-group-margin is-fullwidth"
                        type="is-success"  
                        @click="searchRegsiterByPhoneno"
                        >  <span > ຄົ້ນຫາ</span>
                    </b-button>
                </div>
              </div>
            </div>
          </div>
          <div class="columns" v-if="phoneNoEventList.length == 0 && isSearch" style="margin-bottom: 20px; margin-top: -60px;">
            
            <div class="column">
              ຜົນການຄົ້ນຫາ: <span class="red16bold">ບໍ່ພົບຂໍ້ມູນ</span>
            </div>
          </div>
          <div class="columns" v-if="phoneNoEventList.length > 0" style="margin-top: -50px;">
            
            <div class="column">
              <span class="title16">ຜົນການຄົ້ນຫາ</span>
              <table class="table is-fullwidth is-narrow is-small" >
                <thead>
                  <tr>
                    <th class="has-text-left " width="2%">
                      #
                    </th>
                    <th class="has-text-left " width="60%">
                      ລາຍລະອຽດ
                    </th>
                    
                    <th class="has-text-centered " width="20%">
                      ເຂົ້າຮ່ວມງານ
                    </th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in phoneNoEventList"
                    :key="data.ID"
                  >
                    <td class="has-text-left ">
                      {{ index +1 }}
                    </td>
                    <td class="has-text-left ">
                      {{ data.PHONENO }} <br> {{ data.FULLNAME }} 
                    </td> 
                    <td class="has-text-centered ">
                      <!-- <b-field v-if="data.COUNTTHISEVENT >0 " style="color: red;">  
                        ເຂົ້າຮ່ວມງານນີ້ແລ້ວ
                      </b-field>
                      
                      <b-filed v-else>
                        <b-button  
                          class="btn-group-margin is-fullwidth"
                          type="is-success"  
                          @click="doregister(2, data.REGISTERID)"
                          >  <span > ເຂົ້າຮ່ວມງານ {{ selectedEventName }}</span>
                        </b-button>
                      </b-filed> -->
                      <b-field>  
                        <Multiselect     
                          placeholder="ຈຳນວນຜູ້ຕິດຕາມ"
                          v-model.trim="data.selectedSearchFollower"
                          label="NAME"
                          track-by="ID"
                          :options="followerList"   
                        ></Multiselect>
                      </b-field>
                      <b-field>
                        <b-input
                          placeholder="ລະຫັດກວດສອບ"
                          v-model.trim="data.approveCode"
                          type="password"
                        >  
                        </b-input>
                      </b-field>
                      <b-field>
                        <b-button class="btn-group-margin is-fullwidth" style="margin-top: 0px;"
                            type="is-danger"  
                            @click="checkParticipate(data)"
                            >  <span >ກົດເຂົ້າຮ່ວມງານເລີຍ</span>
                        </b-button>
                      </b-field>
                      
                        
                        
                        
                  </td> 
                    
                  </tr>
                </tbody>
                
              </table>
            </div>
          </div>
        </div>

        
      <b-tabs v-model="activeTab" v-if="phoneNoEventList.length == 0 && isSearch">
        <b-tab-item label="ລົງທະບຽນເຂົ້າຮ່ວມງານ" v-if="cannotfindevent==1">
          <b-field class="title24" style="margin-top: 15px;" v-if="phoneNoEventList.length == 0 && isSearch"><span style="color: red;" > (ລົງທະບຽນໜ້າງານ)</span> ຟອມລົງທະບຽນເຂົ້າຮ່ວມງານ </b-field>   
          <div class="columns" >
              <div class="column">
                

                <div class="columns" >
                  <div class="column">
                    <b-field label="ຊື່ ແລະ ນາມສະກຸນ">
                      <b-input
                        v-model.trim="selectedFullName"
                        type="text"
                      >  
                      </b-input>
                    </b-field>
                  </div>
                </div>

                <div class="columns" >
                  <div class="column">
                    <b-field label="ຊ່ວງອາຍຸ">
                      <Multiselect     
                        placeholder="ຊ່ວງອາຍຸ"
                        v-model.trim="selectedAge"
                        label="NAME"
                        track-by="ID"
                        :options="ageRangList"   
                      ></Multiselect>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="ເພດ">
                      <Multiselect     
                        placeholder="ເພດ"
                        v-model.trim="selectedGender"
                        label="NAME"
                        track-by="ID"
                        :options="genderList"   
                      ></Multiselect>
                    </b-field>
                  </div>
                </div>

                <div class="columns" >
                  <div class="column">
                    <b-field label="ພາກສ່ວນ (ຖ້າມີ)">
                      <b-input
                        v-model.trim="selectedOrganization"
                        type="text"
                      >  
                      </b-input>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="ຕຳແໜ່ງ (ຖ້າມີ)">
                      <b-input
                        v-model.trim="selectedPosition"
                        type="text"
                      >  
                      </b-input>
                    </b-field>
                  </div>
                </div>

                <div class="columns">
                  <div class="column">
                    <b-field label="ກຸ່ມເຂົ້າຮ່ວມ">
                      <Multiselect     
                        placeholder="ກຸ່ມເຂົ້າຮ່ວມ"
                        v-model.trim="selectedSection"
                        label="NAME"
                        track-by="ID"
                        :options="selectionList"   
                      ></Multiselect>
                    </b-field> 
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <b-field label="ຫົວຂໍ້ທີ່ສົນໃຈ">
                      <Multiselect     
                        placeholder="ຫົວຂໍ້ທີ່ສົນໃຈ"
                        v-model.trim="selectedInterested"
                        label="NAME"
                        track-by="ID"
                        :options="interestedList"   
                      ></Multiselect>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="ຈຳນວນຜູ້ຕິດຕາມ (ຖ້າມີ)">
                      <Multiselect     
                        placeholder="ຈຳນວນ"
                        v-model.trim="selectedFollower"
                        label="NAME"
                        track-by="ID"
                        :options="followerList"   
                      ></Multiselect>
                    </b-field>
                  </div>
                </div>
                <div class="columns" >
                  <div class="column">
                    <b-field label="ເບີໂທຕິດຕໍ່">
                      <b-input
                        v-model.trim="selectedPhoneNo"
                        type="text"
                      >  
                      </b-input>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="ລະຫັດກວດສອບ">
                      <b-input
                        placeholder="ລະຫັດກວດສອບ"
                        v-model.trim="approveCode"
                        type="password"
                      >  
                      </b-input>
                    </b-field>
                    
                  </div>
                </div>

                <div class="columns" >
                  <div class="column">
                    <b-field label="" style="margin-top: 30px;">
                      <b-button
                          class="btn-group-margin is-fullwidth"
                          type="is-success"  
                          @click="doregister()"
                          >  <span > ລົງທະບຽນ ແລະ ເຂົ້າງານເລີຍ</span>
                      </b-button>
                    </b-field>
                  </div>
                </div>


               
              
                
                
                
              </div>
                
              <div class="column">
                
              </div>
              
                
            </div>
        </b-tab-item>  
        <b-tab-item label="ລົງບຽນສຳເລັດ" v-if="cannotfindevent==1">
          <div class="columns" v-if="participateFullname">   
            <div class="column">
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ຊື່ ແລະ ນາມສະກຸນ: </span><span  class="title16">{{ participateFullname }} </span>
              </b-field>
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ອາຍຸ: </span><span   style="margin-right: 5px;" class="title16">{{ participateAge }} </span>
              </b-field>
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ເພດ: </span><span  class="title16">{{ participateGender }} </span>
              </b-field>
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ພາກສ່ວນ: </span><span  class="title16">{{ participateOrganization }} </span>
              </b-field>
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ຕຳແໜ່ງ: </span><span  class="title16">{{ participatePosition }} </span>
              </b-field>
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ກຸ່ມເຂົ້າຮ່ວມ: </span><span  class="title16">{{ participateSection }} </span>
              </b-field>
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ຫົວຂໍ້ທີ່ສົນໃຈ: </span><span  class="title16">{{ participateInterested }} </span>
              </b-field>
              <b-field>
                <span  class="title16-light" style="margin-right: 10px;">ເບີໂທ: </span><span  class="title16">{{ participatePhoneNo }} </span>
              </b-field>

              <b-field class="red16bold"> 
                ✅ ລົງທະບຽນສຳເລັດແລ້ວ
              </b-field><br>

              <!-- <b-field class="title16"> 
                ນຳໃຊ້ QR ນີ້ເພື່ອແຈ້ງເຂົ້າງານ
              </b-field>
                
              <b-field v-if="participateFullname">
                <img :src="qrCodeUrl" alt="QR Code" />  
              </b-field>   -->
            </div>
          
          </div>

          <div class="columns" v-if="participateFullname">  
            <div class="column" >
              <b-field style=" display: block; margin-bottom: 0px; width: 330px; padding: 5px 10px 10px 10px;  
                              border-radius: 10px; display: block; border: 2px solid #039BE5;" >
                <b-field style="text-align: center; display: flex; justify-content: center; align-items: center; ">
                  <b-field style=" width: 175px; text-align: right">
                    <img :src="forestlogo"  width="75%"/>
                  </b-field>

                  <b-field style="  width: 175px; text-align: left; padding-left: 10px; margin-top: -10px;">  
                    <img :src="labalogo" width="68%"/>
                  </b-field>
                  
                  
                </b-field>
                <b-field style="text-align: center; display: flex; justify-content: center; align-items: center; margin-top: -25px; margin-bottom: -5px;">
                    <b-field style="background-color: #039BE5; width: 370px; text-align: center; color: white; font-size: 20px;
                                padding: 5px; border-radius: 5px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); display: block; margin-bottom: 10px;"> 
                        ບັດເຂົ້າຮ່ວມງານ Agri-Expo 2024
                    </b-field>
                </b-field>
                
                <b-field style="padding: 10px 0px 0px 0px; "> 
                  <b-field style="width: 85px; background-color: #039BE5; color: white; height: 130px;
                                  padding: 5px 5px 5px 5px; border-radius: 5px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); display: block;">
                    ຊື່ ແລະ <br>ນາມສະກຸນ 
                  </b-field>
                  <b-field style="width: 265px; color: black; height: 130px; margin-left: 5px;
                                  padding: 5px 5px 5px 5px; border-radius: 5px; display: block; border: 2px solid #039BE5;">
                    {{participateFullname}}
                  </b-field>  
                    
                </b-field>
                <b-field style="padding: 10px 0px 0px 0px; margin-top: -20px;  " v-if="participatePosition">
                  <b-field style="width: 85px; background-color: #039BE5; color: white; height: 60px;
                                  padding: 5px 5px 5px 5px; border-radius: 5px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); display: block;">
                    ຕຳແໜ່ງ 
                  </b-field>
                  <b-field style="width: 265px; color: black; height: 60px; margin-left: 5px; 
                                  padding: 5px 5px 5px 5px; border-radius: 5px; display: block; border: 2px solid #039BE5;
                                  ">
                    {{ participatePosition}}
                  </b-field>
                    
                </b-field>
                <b-field style="padding: 10px 0px 0px 0px; margin-top: -20px; " v-if="participateOrganization">
                  <b-field style="width: 85px; background-color: #039BE5; color: white; height: 60px;
                                  padding: 5px 5px 5px 5px; border-radius: 5px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); display: block;">
                    ພາກສ່ວນ 
                  </b-field>
                  <b-field style="width: 265px; color: black; height: 60px; margin-left: 5px; 
                                  padding: 5px 5px 5px 5px; border-radius: 5px; display: block; border: 2px solid #039BE5;
                                  ">
                    {{ participateOrganization}} 
                  </b-field>
                    
                </b-field>
                <b-field style="padding: 10px 0px 0px 0px; margin-top: -20px; ">
                  <b-field style="width: 85px; background-color: #039BE5; color: white; height: 35px;
                                  padding: 5px 5px 5px 5px; border-radius: 5px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); display: block;">
                    ເບີໂທ 
                  </b-field>
                  <b-field style="width: 265px; color: black; height: 35px; margin-left: 5px; 
                                  padding: 5px 5px 5px 5px; border-radius: 5px; display: block; border: 2px solid #039BE5;
                                  ">
                    {{ participatePhoneNo }}
                  </b-field>
                    
                </b-field>
                <b-field style="text-align: center; display: block; margin-bottom: -5px; margin-top: -10px;"> 
                    <img :src="qrCodeUrl" alt="QR Code" />   
                </b-field>
            </b-field>

                
              
            </div>
          </div>
        </b-tab-item>  
      </b-tabs>
          
      
    </div>


    

    

    
    
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";
// import axios from "axios";


// import { BFormSelect } from 'bootstrap-vue'



export default {
  // components: { Multiselect, BFormSelect},
  components: { Multiselect },

  props: {
  },
  data() {
    return {
      roleid: null,
      userName: null,

      activeTab: 0,

      selectedEventID: null,
      selectedEventName: null, 
      
      selectedFullName: null,
      selectedAge: null,
      ageRangList: [],
      genderList:[] ,
      selectedGender: null,
      selectedPhoneNo: null,
      selectionList: [],
      selectedSection: null,

      selectedInterested: null,
      interestedList: [],

      selectedOrganization: null,
      selectedPosition: null,

      participateOrganization: null, 
      participatePosition: null,
      participateFullname: null,
      participateAge: null,
      participateGender: null,
      participateSection: null,
      participateInterested: null,
      participatePhoneNo: null,
      participateStatus: null,

      cannotfindevent: 0,

      regsiterByPhoneno: null,

      phoneNoEventList:[],

      isSearch: 0,

      followerList: [
        {ID: 0, NAME: 'ບໍ່ມີຜູ້ຕິດຕາມ'},
        {ID: 1, NAME: 'ຜູ້ຕິດຕາມ 1'},
        {ID: 2, NAME: 'ຜູ້ຕິດຕາມ 2'},
        {ID: 3, NAME: 'ຜູ້ຕິດຕາມ 3'},
        {ID: 4, NAME: 'ຜູ້ຕິດຕາມ 4'},
        {ID: 5, NAME: 'ຜູ້ຕິດຕາມ 5'},
        {ID: 6, NAME: 'ຜູ້ຕິດຕາມ 6'},
        {ID: 7, NAME: 'ຜູ້ຕິດຕາມ 7'},
        {ID: 8, NAME: 'ຜູ້ຕິດຕາມ 8'},
        {ID: 9, NAME: 'ຜູ້ຕິດຕາມ 9'},
        {ID: 10, NAME: 'ຜູ້ຕິດຕາມ 10'},
      ],

      approveCode: null,

      selectedFollower: null,
        
    
      
    };
     
    
  },
  methods: {     

    checkParticipate(data){
      this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        }).then((result) => {
        if (result.value) {

          const loadingComponent = this.$loading.open({});  
          var params = {
            regno: data.REGNO,  
            eventid: data.EVENTID,  
            activeeventid: this.selectedEventID,
            fullname: data.FULLNAME,
            position: data.POSITION,
            organization: data.ORGANIZATION,
            age: data.AGE,
            gender: data.GENDER,
            section: data.SECTIONID,
            interested: data.INTERESTED,
            follower: data.selectedSearchFollower ? data.selectedSearchFollower.ID : 0,
            phoneno: data.PHONENO,
            self: data.SELFREGISTER,
            approvecode:  this.sha2(data.approveCode),

          }; 

          // console.log("params: "+JSON.stringify(params))
          RestAPI.checkEventParticipate(params)
            .then((res) => {
              loadingComponent.close();
              if(res.data.responseData.data==='approvecode is not correct'){
                this.$swal("approvecode ບໍ່ຖືກຕ້ອງ", "-", "error");
                return false;
              }
 
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.regsiterByPhoneno = null;
              this.phoneNoEventList= [];
              this.isSearch = 0;
              

            })
            .catch((error) => {
              console.log(error); 
              this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
            });
        }
      });
        
    },

    searchRegsiterByPhoneno(){
      this.activeTab = 0;
      this.participateOrganization = null;
      this.participatePosition =null;
      this.participateFullname =null;
      this.participateAge = null;
      this.participateGender =null;
      this.participateSection = null;
      this.participateInterested = null;
      this.participatePhoneNo = null;
      this.isSearch = 1;
      var params = {
        phoneno: this.regsiterByPhoneno,
        eventid: this.selectedEventID,
        username: this.username,  
      };
      RestAPI.searchRegsiterByPhoneno_public(params)
        .then((res) => {
          this.selectedOrganization = null;
          this.selectedPosition = null;
          this.selectedFullName = null;
          this.selectedAge = null;
          this.selectedGender = null;
          this.selectedSection = null;
          this.selectedPhoneNo = null;
          this.selectedInterested = null;
          this.phoneNoEventList = res.data.responseData.data.list;

          if(this.phoneNoEventList.length ==0){
            this.selectedPhoneNo = this.regsiterByPhoneno;
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    doregister(){
      if(  !this.selectedFullName || this.selectedFullName === null || 
            !this.selectedAge || this.selectedAge === null ||  
            !this.selectedGender || this.selectedGender === null || 
            !this.selectedSection || this.selectedSection === null || 
            !this.selectedInterested || this.selectedInterested === null ||
            !this.selectedPhoneNo || this.selectedPhoneNo=== null ||
            !this.approveCode || this.approveCode=== null )     {
              this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ", "", "warning");
              return false;
      }
      

      
      this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
        if (result.value) {

          var params = {
            organization: this.selectedOrganization,
            position: this.selectedPosition,
            fullname: this.selectedFullName,
            age: this.selectedAge.ID,
            gender: this.selectedGender.ID,
            section: this.selectedSection.ID,
            interested: this.selectedInterested.ID,
            phoneno: this.selectedPhoneNo,
            eventid: this.selectedEventID,
            follower: this.selectedFollower ? this.selectedFollower.ID : 0,
            approvecode: this.sha2(this.approveCode),
          };
            
          // console.log("params: "+JSON.stringify(params))
            
            RestAPI.doselfregisterbystaff(params) 
              .then((res) => {

                  if(res.data.responseData.data=== 'Duplicate phoneno'){
                    this.$swal("ເບີໂທລະສັບ ໄດ້ຖືກນຳໃຊ້ແລ້ວ, ກະລຸນາກວດຄືນ", "", "warning");
                    return;
                  }

                  if(res.data.responseData.data=== 'Duplicate record'){
                    this.$swal("ລາຍການຊ້ຳ, ກະລຸນາກວດຄືນ", "", "warning");
                    return;
                  }

                  if(res.data.responseData.data==='approvecode is not correct'){
                    this.$swal("approvecode ບໍ່ຖືກຕ້ອງ", "-", "error"); 
                    return false;
                  }


                  this.$swal({
                    title: "ສຳເລັດ",
                    text: "ລົງທະບຽນ ສຳເລັດ!",
                    icon: "success",
                    timer: 500,
                    showConfirmButton: false, 
                  });

                  this.qrData = "https://lababiz.com/#/event/checkParticipate/"+ res.data.responseData.data.REGNO;
                  // this.qrData = "https://lababiz.com/demo/#/event/checkParticipate/"+ res.data.responseData.data.REGNO;

                  this.selectedOrganization = null;
                  this.selectedPosition = null;
                  this.selectedFullName = null;
                  this.selectedAge = null;
                  this.selectedGender = null;
                  this.selectedSection = null;
                  this.selectedPhoneNo = null;
                  this.regsiterByPhoneno = null;
                  this.selectedInterested = null;

                  this.participateOrganization = res.data.responseData.data.ORGANIZATION;
                  this.participatePosition = res.data.responseData.data.POSITION;
                  this.participateFullname = res.data.responseData.data.FULLNAME;
                  this.participateAge = res.data.responseData.data.AGETITLE;
                  this.participateGender = res.data.responseData.data.GENDERTITLE;
                  this.participateSection = res.data.responseData.data.SECTIONNAME;
                  this.participateInterested = res.data.responseData.data.INTERESTEDTITLE;  
                  this.participatePhoneNo = res.data.responseData.data.PHONENO;
 
                  this.activeTab = 1;

              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
            });
        }
      });
      
    },

    getSection() {
      RestAPI.getSection()
        .then((res) => {
          this.selectionList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getGender() {
      RestAPI.getGender()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.genderList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getAgeRang() {
      RestAPI.getAgeRang()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.ageRangList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getInterested() {
      RestAPI.getInterested()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.interestedList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getEventInfo_Current() {
      var params = {
            eventid: null,
          };
      RestAPI.getEventInfo_Current(params)
        .then((res) => {
          if(res.data.responseData.data=="Event not found"){
            this.$swal("ບໍ່ພົບບລາຍການ", "-", "error");
            this.cannotfindevent = 0;
            return false;
          }

          this.cannotfindevent = 1;
          // console.log("con: "+ JSON.stringify(res.data))
          this.selectedEventID = res.data.responseData.data.ID;
          this.selectedEventName = res.data.responseData.data.NAME;
          
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
   

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
 
    

    

  },
  mounted() {
    // this.roleid = this.user ? this.user.ROLEID : null;
    this.roleid = 3;
    // this.username = this.user.USERNAME;   

    this.currentDate = new Date();
    
    this.getSection();
    this.getGender();
    this.getAgeRang();
    this.getInterested();

    this.getEventInfo_Current();

    
    

  
  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

    qrCodeUrl() {
      // Use the qrserver API to generate the QR code image URL
      return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(this.qrData)}`;
    },

    labalogo() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/logo/labalogo.png'
        : 'http://localhost/lababiz/api/uploads/logo/labalogo.png';
    },

    forestlogo() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/logo/forestlogo.png'
        : 'http://localhost/lababiz/api/uploads/logo/forestlogo.png';
    },

   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

.centered-content {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.card {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;  
  margin-bottom: 0px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.content{
  font-size: 16px;
  margin-left: 5px; 
  margin-right: 5px;
}

.title24{
  font-size: 24px;
  font-weight: bold;
}

.title24-light{
  font-size: 24px;
}

.title20{
  font-size: 20px;
  font-weight: bold;
}

.title20-light{
  font-size: 20px;
}

.title16{
  font-size: 18px;
  font-weight: bold;
}

.title16-light{
  font-size: 18px;
}

.title14{
  font-size: 16px;
  font-weight: bold;
}
.title14-light{
  font-size: 16px;
  font-weight: bold;
}

.title12{
  font-size: 14px;
  font-weight: bold;
}

.title12-light{
  font-size: 14px;
}

.red16bold{
  color: red;
  font-size: 18px;
  font-weight: bold;
}

.red16{
  color: red;
  font-size: 18px;
  
}

.red14bold{
  color: red;
  font-size: 16px;
  font-weight: bold;
}

.red14{
  color: red;
  font-size: 16px;
}

.red12bold{
  color: red;
  font-size: 14px;
  font-weight: bold;
}

.red12{
  color: red;
  font-size: 14px;
}




.container{  
  margin-top: 10px;
}
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

@media (min-width: 768px) {
  .product-name {
    width: auto; /* Restores the default behavior on larger screens */
    margin-top: 0;
  }
}
.column-50 {
  flex: 0 0 50%;
}

.column-65 {
  flex: 0 0 65%;
}

.column-35 {
  flex: 0 0 35%;
}

.column-30 {
  flex: 0 0 30%;
}
.column-70 {
  flex: 0 0 70%;
}

.column-20 {
  flex: 0 0 20%;
}
.column-80 {
  flex: 0 0 80%;
}


.asterisk {
  color: red;
}
  
.set-border {
  border: 1px solid #838282;      
}

tbody tr:last-child td {
  border-bottom: 1px solid #000; /* Specifically target the last row's bottom border */
}

.summary-footer {
  page-break-before: always;
}

.modal {  
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
